import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Users, Book, Award, Activity } from 'lucide-react';

const Dashboard = () => {
  const { userRole, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect after loading is complete and we have role info
    if (!isLoading) {
      if (userRole) {
        // Redirect to role-specific dashboard
        switch (userRole) {
          case 'admin':
            navigate('/admin', { replace: true });
            break;
          case 'formateur':
            navigate('/trainer', { replace: true });
            break;
          case 'etudiant':
            navigate('/student', { replace: true });
            break;
          default:
            // Stay on the dashboard if unknown role
            break;
        }
      }
      // If no role is assigned yet, stay on this generic dashboard
    }
  }, [userRole, isLoading, navigate]);

  // This page is mainly a router - users should be redirected to role-specific dashboards
  return (
    <div className="animate-fade-in">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Tableau de bord</h1>
        <p className="mt-2 text-gray-600">
          Bienvenue sur FormaNote by FormaVerse, votre système de gestion des notes
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg font-semibold text-gray-900">Étudiants</p>
              <p className="text-3xl font-bold mt-2 text-primary-600">--</p>
            </div>
            <div className="bg-primary-100 p-3 rounded-full">
              <Users className="h-6 w-6 text-primary-600" />
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg font-semibold text-gray-900">Matières</p>
              <p className="text-3xl font-bold mt-2 text-secondary-600">--</p>
            </div>
            <div className="bg-secondary-100 p-3 rounded-full">
              <Book className="h-6 w-6 text-secondary-600" />
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg font-semibold text-gray-900">Notes</p>
              <p className="text-3xl font-bold mt-2 text-accent-600">--</p>
            </div>
            <div className="bg-accent-100 p-3 rounded-full">
              <Award className="h-6 w-6 text-accent-600" />
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg font-semibold text-gray-900">Moyenne</p>
              <p className="text-3xl font-bold mt-2 text-success-500">--</p>
            </div>
            <div className="bg-success-50 p-3 rounded-full">
              <Activity className="h-6 w-6 text-success-500" />
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-8 text-center">
        <p className="text-gray-600">
          {isLoading 
            ? "Chargement de votre profil..." 
            : "Redirection vers votre tableau de bord personnalisé..."}
        </p>
      </div>
    </div>
  );
};

export default Dashboard;